import React from 'react';
import { IconButton, Badge, DataGridIcon } from '@cherre-frontend/ui';
import { unifiedIngestListTransformTemplates } from '../services/dsp/unifiedIngestListTemplates';
import { unifiedIngestListTemplatesQuery } from '../services/dsp/__generated__/unifiedIngestListTemplatesQuery.graphql';
import { useSelector } from 'react-redux';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay';
import { useDspRelayEnvironment } from 'src/products/connector/pages/connector-details/components/DataValidationV2/hooks/useDspRelayEnvironment';
type ModelLibrarySectionProps = {
  targetTableName?: string;
  handleIconClick?: () => void;
};
export const TemplateIcon: React.FC<ModelLibrarySectionProps> = ({
  targetTableName,
  handleIconClick,
}) => {
  const { domOwner, organizationSlug } = useSelector(
    (state) => state.user.profile.value
  );

  const tableTemplateCount =
    useLazyLoadQuery<unifiedIngestListTemplatesQuery>(
      unifiedIngestListTransformTemplates,
      {
        params: {
          owner_name: domOwner ?? '',
          org_slug: organizationSlug ?? '',
          target_table: targetTableName,
        },
      }
    )?.unified_ingest_transform_templates_list?.templates_list?.length ?? 0;
  const color = tableTemplateCount ? 'success' : 'error';
  return (
    <IconButton
      data-testid='DataGridIconButton'
      sx={{ height: '20px', width: '20px' }}
      color={color}
      onClick={handleIconClick}
    >
      <Badge
        showZero
        badgeContent={tableTemplateCount}
        color={color}
        sx={{ span: { color: 'white' } }}
      >
        <DataGridIcon />
      </Badge>
    </IconButton>
  );
};

const TemplateIconWrapper: React.FC<ModelLibrarySectionProps> = ({
  targetTableName,
  handleIconClick,
}) => {
  const environment = useDspRelayEnvironment();

  if (!environment) {
    return null;
  }
  return (
    <RelayEnvironmentProvider environment={environment}>
      <TemplateIcon
        targetTableName={targetTableName}
        handleIconClick={handleIconClick}
      />
    </RelayEnvironmentProvider>
  );
};

TemplateIconWrapper.displayName = 'TemplateIconWrapper';
export default TemplateIconWrapper;
